/* eslint-disable jsx-a11y/heading-has-content */
import React, { useEffect, useRef } from 'react'
import Heading from 'shared/ui/Heading'

export default function FocusedHeader(props) {
  const ref = useRef()

  useEffect(() => {
    // we were getting a weird "focus on undefined" error
    ref.current && ref.current.focus()
  }, [])

  return <Heading ref={ref} {...props} tabIndex="-1" />
}
